/**
 * Значок инициатора у имени конторы: вилку дал кэф этой конторы. Куратору это
 * важно для жизни аккаунта. Числа контор нет ни на ленте, ни в подсказке — оно
 * ставку не меняет (снято 20.09). Нет поля — нет значка.
 */

export type InitiatorBy = 'ours' | 'mirror';

export type InitiatorMark =
  | { kind: 'none' }
  | { kind: 'filled'; count: number | null; by: InitiatorBy | null }
  | { kind: 'empty'; count: number | null; by: InitiatorBy | null }
  | { kind: 'bare'; by: InitiatorBy | null };

export function initiatorMark(
  leg: { initiator?: boolean; initiatorCount?: number | null },
  by?: InitiatorBy | string | null,
): InitiatorMark {
  const proven: InitiatorBy | null = by === 'ours' || by === 'mirror' ? by : null;
  const raw = leg.initiatorCount;
  const count = typeof raw === 'number' && Number.isFinite(raw) ? raw : null;
  if (leg.initiator === true) {
    return count === null
      ? { kind: 'bare', by: proven }
      : { kind: 'filled', count, by: proven };
  }
  if (leg.initiator === false && count !== null) {
    return { kind: 'empty', count, by: proven };
  }
  return { kind: 'none' };
}

export function initiatorTitle(mark: InitiatorMark): string {
  if (mark.kind === 'none' || mark.kind === 'empty') return '';
  return 'инициатор вилки';
}

export function initiatorDetail(mark: InitiatorMark): string {
  return initiatorTitle(mark);
}

/**
 * Номер единственной ноги-инициатора, иначе -1. Инициатор — контора, чей кэф
 * завышен против рынка: на её ошибке и строится вилка. Две ноги с признаком
 * (зеркало не различило, у обеих один count) — не знаем, значок не рисуем.
 */
export function soleInitiator(legs: readonly { initiator?: boolean }[]): number {
  let at = -1;
  for (let i = 0; i < legs.length; i += 1) {
    if (legs[i]!.initiator !== true) continue;
    if (at !== -1) return -1;
    at = i;
  }
  return at;
}
